import React from 'react';
import PropTypes from 'prop-types';

const DateRangeSelector = ({
	startDate,
	endDate,
	loading,
	isDataStillUpdating,
	quickRangeValue,
	onStartDateChange,
	onEndDateChange,
	onQuickRangeSelect,
	onlyCompleted = false,
	onToggleOnlyCompleted,
}) => {
	const today = new Date();

	return (
		<div className='flex flex-wrap gap-4'>
			<div>
				<label className='block text-sm mb-1'>Quick Range</label>
				<select
					className='p-2 border rounded-md'
					value={quickRangeValue}
					onChange={onQuickRangeSelect}
					disabled={loading || isDataStillUpdating}
				>
					<option value="">Custom Range</option>
					<option value="current_week">Current Week</option>
					<option value="previous_week">Previous Week</option>
					<option value="current_month">Current Month</option>
					<option value="previous_month">Previous Month</option>
					<option value="current_year">Current Year</option>
					<option value="2">2 Weeks</option>
					<option value="3">3 Weeks</option>
					<option value="4">4 Weeks</option>
				</select>
			</div>
			<div>
				<label className='block text-sm mb-1'>Start Date</label>
				<input
					type='date'
					value={startDate.toISOString().slice(0, 10)}
					onChange={onStartDateChange}
					max={endDate.toISOString().slice(0, 10)}
					className='p-2 border rounded-md'
					disabled={loading || isDataStillUpdating}
				/>
			</div>
			<div>
				<label className='block text-sm mb-1'>End Date</label>
				<input
					type='date'
					value={endDate.toISOString().slice(0, 10)}
					onChange={onEndDateChange}
					min={startDate.toISOString().slice(0, 10)}
					max={today.toISOString().slice(0, 10)}
					className='p-2 border rounded-md'
					disabled={loading || isDataStillUpdating}
				/>
			</div>
			{/* Completed tasks toggle */}
			<div className='flex flex-col justify-end'>
				<div className='flex items-center h-10'>
					<span className='text-sm mr-2'>Only completed</span>
					<label className='relative inline-flex items-center cursor-pointer'>
						<input
							type='checkbox'
							checked={onlyCompleted}
							onChange={() => onToggleOnlyCompleted && onToggleOnlyCompleted()}
							className='sr-only peer'
							disabled={loading || isDataStillUpdating}
						/>
						<div className={`w-11 h-6 bg-gray-400 peer-focus:outline-none peer-focus:ring-4
							peer-focus:ring-blue-300 rounded-full peer
							${onlyCompleted ? 'after:translate-x-full after:border-blue-600 after:bg-blue-600' : 'after:bg-white'}
							after:content-[''] after:absolute after:top-[2px] after:left-[2px]
							after:border after:rounded-full after:h-5 after:w-5
							after:transition-all ${loading || isDataStillUpdating ? 'opacity-50 cursor-not-allowed' : ''}`}></div>
					</label>
				</div>
			</div>
		</div>
	);
};

DateRangeSelector.propTypes = {
	startDate: PropTypes.instanceOf(Date).isRequired,
	endDate: PropTypes.instanceOf(Date).isRequired,
	loading: PropTypes.bool.isRequired,
	isDataStillUpdating: PropTypes.bool.isRequired,
	quickRangeValue: PropTypes.string.isRequired,
	onStartDateChange: PropTypes.func.isRequired,
	onEndDateChange: PropTypes.func.isRequired,
	onQuickRangeSelect: PropTypes.func.isRequired,
	onlyCompleted: PropTypes.bool,
	onToggleOnlyCompleted: PropTypes.func,
};

export default DateRangeSelector;
